import {Component, OnInit, ViewChild} from '@angular/core';
import {ModalController, NavController, Platform} from "@ionic/angular";
import {HttpHelperService} from "./services/http-helper.service";
import {NotificationService, PushPermissions} from "./services/notification.service";
import {NotificationPopupComponent} from "./components/notification-popup/notification-popup.component";
import {ConfigService} from "./services/config.service";
import {AppPlatform} from "./services/models/app-platform";
import {PushNotifications} from "@capacitor/push-notifications";
import {AuthenticationService} from "./services/authentication.service";
import {UserService} from "./services/user.service";

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  @ViewChild('popup')popup!: NotificationPopupComponent;
  showNotification: boolean = false;
  showCookies!: boolean;
  isInitialized: boolean = false;
  constructor(
    private modalCtrl: ModalController,
    private platform: Platform,
    private httpHelper: HttpHelperService,
    private notificationSrv: NotificationService,
    private configService: ConfigService,
    private navCtrl: NavController,
    private authSrv: AuthenticationService,
    private userService: UserService
  ) {

  }
  async pushPermissionChanged(permStatus: PushPermissions) {
    // console.log('Notification status changed: ' + permStatus);
    if (permStatus === PushPermissions.granted) {
      // console.log('Notification status granted -> listening for notifications');
      await this.startListeningForNotifications();
      // console.log('Notification status granted -> listening for notifications -> LISTENING');
    } else {

    }
    return permStatus;
  }
  async initPush() {
    await this.startListeningForNotifications();
    // console.log('Initializing push permissions');
    return await this.notificationSrv.checkPushPermissions();
  }
  initializePlatformVariables() {
    if (this.platform.is('desktop') || this.platform.is('mobileweb')) {
      this.initVersion();
      this.httpHelper.isVersionValid = true;
      // this.initVersion();
      this.httpHelper.appPlatform = AppPlatform.desktop;
      this.httpHelper.clientUid = '8CC92B47-CFD9-4082-BA75-C6C11082D305';
      this.showCookies = true;
    } else if (this.platform.is('ios') && this.platform.is('hybrid')) {
      this.initVersion();
      this.httpHelper.appPlatform = AppPlatform.iOS;
      this.httpHelper.clientUid = 'CF951E8A-5C00-4487-A26C-5688EE829D52';
      //this.httpHelper.shouldShowBackButton = true;
      //this.statusBar.styleDefault();
    } else if (this.platform.is('android') && this.platform.is('hybrid')) {
      this.initVersion();
      this.httpHelper.appPlatform = AppPlatform.android;
      //this.apiService.shouldShowBackButton = true;
      this.httpHelper.clientUid = 'C0F081B7-9F14-42A9-8115-B08E1C5CAF31';
      //this.statusBar.styleLightContent();
      //this.statusBar.backgroundColorByHexString('#DE1274');
    } else {
      this.httpHelper.clientUid = '92103ED7-7A0A-45EB-B297-94D6E546DC21';
    }
    this.httpHelper.platforms = this.platform.platforms().toString();
    this.isInitialized = true;
  }
  initVersion() {
    this.configService.getValue('min_version')
      .then((r: any) => {
        console.log('version initialized');
        this.httpHelper.isVersionValid = this.httpHelper.versionNumber.replace('web.','') >= r.value.replace('web.','');
        if (!this.httpHelper.isVersionValid) {
          console.log('invalid version');
          this.navCtrl.navigateRoot("/update");
        }
        console.log(`app version: ${this.httpHelper.versionNumber} >= ${r.value} : ${this.httpHelper.isVersionValid}`);
      }).catch(e => {
    });
  }
  async ngOnInit() {
    this.platform.ready().then(async result => {
      this.initializePlatformVariables();
      const isAuthenticated = this.authSrv.isAuthenticated();
      if (isAuthenticated) {
        this.notificationSrv.evPermissionStatusChanged.subscribe(async (permStatus) => {
          console.log('Notification status changed: ' + permStatus);
        });
        this.notificationSrv.evShowNotification.subscribe(result => {
          this.popup.showMessage(result);
        });
      }
      if (
        this.platform.is("capacitor") &&
        (
          this.platform.is("ios") ||
          this.platform.is("android")
        ))
      {
        const pushResult = await this.initPush();
      }
    });
  }
  async startListeningForNotifications() {
    await PushNotifications.addListener('registration', async token => {
      console.info('Registration token: ', token.value);
      await this.userService.userSetProperty('push', token.value);
    });
    await PushNotifications.addListener('registrationError', err => {
      console.error('Registration error: ', err.error);
    });
    await PushNotifications.addListener('pushNotificationReceived', notification => {
      console.log('Push notification received: ', notification);
    });
    await PushNotifications.addListener('pushNotificationActionPerformed', notification => {
      console.log('Push notification action performed', notification.actionId, notification.inputValue);
    });
  }
}
